module.exports = __webpack_public_path__ + "img/badge-list-thumb-121.012f4e34.png";